import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './baseQuery';

export const usersApi = createApi({
  reducerPath: 'usersApi',
  baseQuery: baseQueryWithReauth,
  refetchOnFocus: true,
  refetchOnReconnect: true,
  endpoints: (builder) => ({
    getUsers: builder.query({
      query: () => ({
        url: 'users',
      }),
      providesTags: ['Users'],
    }),
    addUser: builder.mutation({
      query: (user) => ({
        url: 'users',
        method: 'POST',
        body: user,
      }),
      invalidatesTags: ['Users'],
      transformResponse: (response) => {
        return response;
      },
    }),
    modifyUser: builder.mutation({
      query: (user) => ({
        url: `users/${user._id}`,
        method: 'PATCH',
        body: user,
      }),
      invalidatesTags: ['Users'],
      transformResponse: (response) => {
      },
    }),
    deleteUser: builder.mutation({
      query: (user) => ({
        url: `users/${user}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Users'],
      transformResponse: (response) => {
        return response;
      },
    }),
    getUser: builder.query({
      query: () => ({
        url: 'users/user',
      }),
      providesTags: ['Users'],
      transformResponse: (response) => {
        return response;
      },
    }),
    updateUserSettings: builder.mutation({
      query: (settings) => ({
        url: 'users/settings',
        method: 'PATCH',
        body: settings,
      }),
      invalidatesTags: ['Users'],
    }),
  }),
});

export const {
  useGetUsersQuery,
  useAddUserMutation,
  useModifyUserMutation,
  useDeleteUserMutation,
  useGetUserQuery,
  useUpdateUserSettingsMutation,
} = usersApi;